<template>
  <div class="container todoListContainer">
    <div class="todosList">
      <div class="col" v-for="todo in todos" :key="todo.todoID">
        <Todo :todo="todo" :pageID="pageID" />
      </div>
    </div>
    <div v-show="todos.length == 0" class="emptyTodoAlert">Nothing here! Add some tasks?</div>
    <button v-on:click="addTodoItem" class="btn btn-outline-dark">
      <i class="fas fa-lg fa-plus-circle addIcon"></i>
      Add Task
    </button>
  </div>
</template>

<script>
import Todo from "@/components/Todo.vue";

export default {
  props: {
    pageID: Number,
    propSectionID: Number
  },
  computed: {
    todos() {
      let res = this.$store.getters.getTodosBySectionID(
        this.pageID,
        this.propSectionID
      );
      return res;
    },
    sectionID() {
      return this.propSectionID;
    },
    maxIndex() {
      return this.$store.getters.maxIndex(this.pageID);
    }
  },
  components: {
    Todo
  },
  methods: {
    addTodoItem() {
      let newTodo = {
        todoID: this.maxIndex + 1,
        title: "",
        sectionID: this.sectionID,
        isDone: false
      };
      this.$store.commit("incrementMaxIndex", {
        pageID: this.pageID,
        maxIndex: this.maxIndex + 1
      });
      this.$store.commit("addOrUpdateTodo", {
        pageID: this.pageID,
        todo: newTodo
      });
    }
  },
  dragOptions() {
    return {
      animation: "200",
      ghostClass: "ghost",
      group: "task-list-items"
    };
  }
};
</script>

<style scoped>
.emptyTodoAlert {
  margin: 1rem;
  font-size: 20px;
}

@media all and (max-width: 769px) {
  .emptyTodoAlert {
    margin: 1rem;
    font-size: 16px;
  }
}
.addTaskBtn {
  padding: 5px;
  border: 1px solid black;
  border-radius: 20px;
}

.todosList {
  margin: 1rem;
}

.addIcon {
  margin-right: 5px;
}

.todoListContainer {
  margin: 1em;
}
</style>